import { useNavigate } from "react-router-dom";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { HistoryIcon } from "../../components/Icons/HistoryIcon";
import { useApp } from "../../contexts";
import { StakeForOptionTable } from "../wallet-list/components/TableStake";
import ArrowLeftIcon from "../../components/Icons/ArrowLeftIcon";

export const StakeForOption = () => {
  const { T } = useApp();
  const navigate = useNavigate();

  const navigateToStakeHistory = () => {
    navigate("/stake-for-option-history");
  }

  const goBack = () => {
    navigate("/stake");
  }

  return (
    <>
      <Container>
        <ContainerView background="transparent">
          <div className="flex justify-between items-center">
            <TitlePage className="flex gap-1 items-center">
              <div className="text-[30px] lg:text-[42px] cursor-pointer" onClick={goBack}>
                <ArrowLeftIcon />
              </div>
              {T("Stake for option")}
            </TitlePage>
            <div
              className="cursor-pointer w-[26px] lg:w-[32px]"
              onClick={navigateToStakeHistory}
            >
              <HistoryIcon/>
            </div>
          </div>
          <StakeForOptionTable />
        </ContainerView>
      </Container>
    </>
  );
};
